module.exports = __webpack_public_path__ + "static/img/search.1b89a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.png
// module id = /DBc
// module chunks = 2